import blank from "app/reducers/blank";
import notifications from "app/reducers/notifications";
import combineReducers from "lib/combine-reducers";

export const createInitialState = ({user, ...app} = {}) => ({
  app: app || {},
  notifications: [],
  user
});

export default combineReducers({
  app: blank,
  notifications,
  user: blank
});
